// extracted by mini-css-extract-plugin
export const container = "showcase-module--container--9330x";
export const image = "showcase-module--image--37A4Y";
export const info = "showcase-module--info--1DxHx";
export const veggies = "showcase-module--veggies--1jtd-";
export const cardamom = "showcase-module--cardamom--mGF6i";
export const lamp1 = "showcase-module--lamp1--3GtWz";
export const lamp2 = "showcase-module--lamp2--2p63R";
export const lamp3 = "showcase-module--lamp3--ERSCy";
export const left = "showcase-module--left--3akXC";